import React from 'react';

const NotFound = (props) => {
    return (
    <div>
       <h2><code>Pagina no encontrada</code></h2>
    </div>    
    );
}

export default NotFound;